// store/features/api/doctorsApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const doctorsApi = createApi({
  reducerPath: "doctorsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}users/doctors`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Doctors"],
  endpoints: (builder) => ({
    getDoctors: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        gender = "",
        status = "",
        expert = "",
      }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
        });

        if (search) params.append("search", search);
        if (gender) params.append("gender", gender);
        if (status !== "") params.append("status", status);
        if (expert) params.append("service_id", expert);

        return `?${params.toString()}`;
      },
      providesTags: ["Doctors"],
    }),

    createDoctor: builder.mutation({
      query: (formData) => ({
        url: "/",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Doctors"],
    }),

    getDoctorDetails: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "Doctors", id }],
    }),

    updateDoctorDetails: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Doctors"],
    }),

    deleteDoctorDetails: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Doctors"],
    }),

    changeDoctorStatus: builder.mutation({
      query: (id) => ({
        url: `/${id}/status`,
        method: "PATCH",
      }),
      invalidatesTags: ["Doctors"],
    }),

    searchDoctor: builder.query({
      query: (keyword) => `/search?keyword=${keyword}`,
    }),

    // Export endpoint
    exportDoctors: builder.query({
      query: ({ search = "", gender = "", status = "", expert = "" }) => {
        const params = new URLSearchParams({ exportExcel: "true" });

        if (search) params.append("search", search);
        if (gender) params.append("gender", gender);
        if (status !== "") params.append("status", status);
        if (expert) params.append("service_id", expert);

        return `?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetDoctorsQuery,
  useCreateDoctorMutation,
  useGetDoctorDetailsQuery,
  useUpdateDoctorDetailsMutation,
  useDeleteDoctorDetailsMutation,
  useChangeDoctorStatusMutation,
  useSearchDoctorQuery,
  useLazyExportDoctorsQuery,
} = doctorsApi;
